module.exports = __webpack_public_path__ + "img/cv.b50df3f.svg";